import styled from 'styled-components';

export const AttachmentWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;
